import { render, staticRenderFns } from "./TicDownloadPdf.vue?vue&type=template&id=0c1d90cc&scoped=true&"
import script from "./TicDownloadPdf.vue?vue&type=script&lang=js&"
export * from "./TicDownloadPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d90cc",
  null
  
)

export default component.exports